import "./Button.css";

function Button({

    children,

    variant = "primary",

    size = "medium",

    icon,

    onClick,

    disabled = false,

    type = "button",

}) {

    return (

        <button

            type={type}

            className={`btn ${variant} ${size}`}

            onClick={onClick}

            disabled={disabled}

        >

            {icon &&

                <span className="btn-icon">

                    {icon}

                </span>

            }

            {children}

        </button>

    );

}

export default Button;